export const actions = {
    CREATE_QR_CODE_ATTENDANCE: 'CREATE_QR_CODE_ATTENDANCE',
    SET_QR_CODE_ATTENDANCE: 'SET_QR_CODE_ATTENDANCE',
    GET_ATTENDANCES_LIST: 'GET_ATTENDANCES_LIST',
    SET_ATTENDANCES_LIST: 'SET_ATTENDANCES_LIST',

    DELETE_ATTENDANCE: "DELETE_ATTENDANCE",

    GENERATE_QR_CODE: "GENERATE_QR_CODE",
    SET_GENERATE_QR_CODE: "SET_GENERATE_QR_CODE",

    GET_ATTENDANCE_STUDENTS_LİST: "GET_ATTENDANCE_STUDENTS_LİST",
    SET_ATTENDANCE_STUDENTS_LİST: "SET_ATTENDANCE_STUDENTS_LİST",

    ADD_STUDENT_TO_ATTENDANCE: "ADD_STUDENT_TO_ATTENDANCE",
    SET_REFRESH_ATTENDANCE: "SET_REFRESH_ATTENDANCE",
    REMOVE_STUDENT_TO_ATTENDANCE: "REMOVE_STUDENT_TO_ATTENDANCE",

    GET_CLASSESS: "GET_CLASSESS",
    SET_CLASSESS: "SET_CLASSESS",

    GET_REFRESH_GENERAL_ATTENDANCE_USER: "GET_REFRESH_GENERAL_ATTENDANCE_USER",

    GET_ACTIVE_ATTENDANCE: "GET_ACTIVE_ATTENDANCE",
    END_ATTENDANCE: "END_ATTENDANCE",
    
    SET_REFRESH_ATTENDANCE_BY_API: "SET_REFRESH_ATTENDANCE_BY_API",
};